import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NoticeDetailComponent from './Detail.component';
import { getNoticeDetail } from 'api/student/v2/notice.api';
import { INotice } from 'api/interfaces/bbs.interface';

const NoticeDetailContainer: React.FC = () => {
    const { noticeId } = useParams<{ noticeId: string }>();
    const [notice, setNotice] = useState<INotice | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadNoticeDetail = async () => {
            if (!noticeId) {
                console.error("❌ noticeId가 없습니다");
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                console.log("🔄 공지사항 상세 조회 시작:", noticeId);
                
                const result = await getNoticeDetail(Number(noticeId));
                console.log("📊 공지사항 상세 API 응답:", result);
                
                if (result?.notice) {
                    setNotice(result.notice);
                    console.log("✅ 공지사항 상세 데이터 설정 완료");
                } else {
                    console.log("⚠️ 공지사항 데이터가 없음");
                    setNotice(null);
                }
            } catch (error) {
                console.error("❌ 공지사항 상세 조회 실패:", error);
                setNotice(null);
            } finally {
                setIsLoading(false);
            }
        };

        loadNoticeDetail();
    }, [noticeId]);

    return (
        <NoticeDetailComponent 
            notice={notice}
            isLoading={isLoading}
        />
    );
};

export default NoticeDetailContainer;
